export default __webpack_public_path__ + "static/p1-c76243e1f48462275a6bce18dfbaae30.png";